import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { configureStore as createStore } from '@reduxjs/toolkit';

import auth from './auth';
import teams from './teams';
import users from './users';
import courses from './courses';
import modules from './modules';
import { reportSlice } from './report';
import overlay from './overlay';
import toc from './toc';
import learner from './learner';
import settings from './settings';
import panes from './panes';
import modal from './modal';
import platformData from './platformData';
import presence from './presence';
import { teamsSlice } from './features/teamsSlice';
import { navPanelSlice } from './features/navPanelSlice';
import { coursesApi } from '../services/courses';
import { usersApi } from '../services/users';

const appEnv = process.env.REACT_APP_ENV;
const middlewares = [thunk, coursesApi.middleware, usersApi.middleware];

if (appEnv === 'development') {
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}

const rootReducer = combineReducers({
  auth,
  teams,
  users,
  courses,
  modules,
  report: reportSlice.reducer,
  overlay,
  toc,
  learner,
  settings,
  panes,
  modal,
  platformData,
  presence,
  teamsSlice: teamsSlice.reducer, // TODO: We can move teams state to this slice in the future
  navPanel: navPanelSlice.reducer,
  [coursesApi.reducerPath]: coursesApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default function configureStore() {
  return createStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
  });
}
